<template>
  <div class="container">
    <b-alert
      variant="success"
      class="thank-you-message mt-4"
      show
    >
      {{ message }}
    </b-alert>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    name: "ThankYou",
    props: {
      message: {
        type: String,
        default: ""
      }
    },
    computed: {
      ...mapGetters(["getContentItem"]),
    },
  };
</script>
